import Link from "next/link";
import React from "react";
import { routesURL } from "../urls";

const Outro = () => {
  return (
    <div className=" flex justify-between items-center pb-[160px] max-sm:pb-[80px] max-sm:flex-col max-sm:items-start max-sm:gap-y-[34px]">
      <h3 className="font-geoGraph font-medium antialiased text-[30px] max-sm:text-[26px] max-sm:leading-tight text-[#ededed]">
        Analyse your data today.
        <br /> Take bolder decisions for tomorrow.
      </h3>
      <div className=" flex items-center gap-x-4 max-sm:w-full">
        <Link href={routesURL.login} target="__blank">
          <button className="flex h-[42px] w-[123px] max-sm:w-[112px] items-center justify-center rounded-[10px] bg-[#f9f9f9] font-inter text-[15px] max-sm:text-[14px] font-regular text-[#000000] shadow-sm transition-[background-color,box-shadow,transform] duration-200 ease-out hover:-translate-y-0.5 hover:bg-white hover:shadow-md active:translate-y-0 active:scale-[0.98]">
            Start now
          </button>
        </Link>
        <Link href={"https://cal.com/blockset/30min"} target="__blank">
          <button className="flex h-[42px] w-[140px] max-sm:w-[136px] items-center justify-center rounded-[10px] bg-[rgba(112,110,106,.3)] font-inter text-[14px] max-sm:text-[13px] font-regular text-[#f9f9f9] transition-[background-color,box-shadow,transform] duration-200 ease-out hover:-translate-y-0.5 hover:bg-[rgba(112,110,106,.45)] hover:shadow-md active:translate-y-0 active:scale-[0.98]">
            Talk to Founder
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Outro;
